module.exports = __webpack_public_path__ + "static/media/paper-light.0cc50d38.png";